import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const getConsents = async () => {
  try {
    return await customFetch(API_ENDPOINTS.CONSENTS, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('同意状態取得エラー:', error);
    throw error;
  }
};

export const consentService = {
  getConsents
};
